import { ListItemIcon as ListItemIconMui, ListItemIconProps as ListItemIconPropsMui, styled } from "@mui/material";
import * as React from "react";

type ListItemIconProps = ListItemIconPropsMui

const StyledListItemIcon = styled(ListItemIconMui)``

const ListItemIcon: React.FC<ListItemIconProps> = props => {
    return <StyledListItemIcon {...props}>
        {props.children}
    </StyledListItemIcon>
}

export default ListItemIcon;